<template>
  <span>
    <a
      :href="`#reference-${refIndex}`"
      data-behavior="modal track"
      data-track-event="clickReference"
      data-track-eventcategory="Reports"
      data-track-eventaction="click references"
      :data-track-eventlabel="`reference-${refIndex}`"
      :data-modal="`modal-reference-${refIndex}`"
      class="modal-reference"
      @click="open = true"
    >
      <slot name="reference">{{ refIndex }}</slot>
    </a>
    <div
      :class="`m-modal m-modal-- ${open ? 's-active' : ''}`"
      data-modal-dialog=""
      role="dialog"
      aria-modal="true"
      :aria-labelledby="`modal-reference-${refIndex}`"
    >
      <div class="m-modal__dialog" role="document">
        <div class="m-modal__header">
          <span
            class="m-modal__title f-ui-1-bold"
            :id="`modal-reference-${refIndex}`"
          >
            {{ modalTitle || `Reference ${refIndex}` }}
          </span>
          <button
            type="button"
            class="m-modal__close"
            data-modal-close=""
            aria-label="Close dialog"
            @click="open = false"
          >
            <Icon icon="close-btn" />
          </button>
        </div>
        <div class="m-modal__body f-body">
          <p></p>
          <slot></slot>
          <p></p>
        </div>
      </div>
    </div>
  </span>
</template>
<script>
/**
 * This component replicates the behavior of references and modals on the website.
 * Does not include the display of the complete list of references at the bottom of the page.
 * Will only work properly on the website (behaviors and specific code missing otherwise).
 * Expects 2 slots:
 * - [required] Default slot that holds the HTML content of the modal.
 * - [optional] "reference" slot to customize the display of the reference button. Defaults to refIndex.
 */
import Icon from "./Icon.vue";
export default {
  components: {
    Icon,
  },
  props: {
    /**
     * Reference index number.
     * Should be unique across the page.
     */
    refIndex: {
      required: true,
      type: Number,
    },
    /**
     * Optional title for the modal.
     * Defaults to Reference {refIndex}.
     */
    modalTitle: {
      required: false,
      type: String,
      default: null,
    },
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>
<style>
.modal-reference > span.icon,
.modal-reference > span.icon > svg {
  width: 16px !important;
  height: 16px !important;
}
.m-modal__body {
  overflow-y: auto;
  max-height: 60vh;
}
.m-modal__body > p {
  margin: 0 !important;
}
</style>
